export enum DialogTypeEnum {
  INFORMATION = 'information',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
  
  COMMON_SHORT = 'common-short',
  COMMON_MEDIUM = 'common-medium',
  COMMON_LONG = 'common-long'
}

export type DialogTypeEnumValues = `${DialogTypeEnum}`;